module.exports = __webpack_public_path__ + "static/media/48366762_2308808749194303_5125859295283380224_o-thumb.219054be.jpg";